import { Icon } from "@iconify/react";
import StepConnector, { stepConnectorClasses } from "@mui/material/StepConnector";
import { styled } from "@mui/material/styles";

export const CustomizedStepConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: { borderColor: "#000080" },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: { borderColor: "#000080" },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: "#d8d8d8",
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

interface StepperIconRootProps {
  ownerState?: { active?: boolean; completed?: boolean };
}

const StepperIconRoot = styled("div", {
  shouldForwardProp: (prop: PropertyKey) => prop !== 'ownerState',
})<StepperIconRootProps>(({ ownerState }) => ({
  display: "flex",
  height: "1.5rem",
  width: "1.5rem",
  alignItems: "center",
  justifyContent: "center",
  border: "1px solid #d8d8d8",
  borderRadius: "50%",
  "& .stepper-label-icon": { color: "#ffffff", fontSize: "1.25rem" },
  ...(ownerState?.completed || ownerState?.active
    ? { backgroundColor: "#000080", borderColor: "#000080" }
    : {}),
}));

interface CustomizedStepperLabelIconProps {
  active?: boolean;
  completed?: boolean;
  className?: string;
}

export function CustomizedStepperLabelIcon({ active, completed, className }: CustomizedStepperLabelIconProps) {
  return (
    <StepperIconRoot ownerState={{ active, completed }} className={className}>
      {completed ? <Icon icon="material-symbols:check" className="stepper-label-icon" /> : ""}
    </StepperIconRoot>
  );
}
